import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/fms/fms_pkos`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}
 
function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/fms/fms_pkos/${id}`, options)
    .then(response => {
      let pko = jsona.deserialize(response.data);
      delete pko.links;
      return pko;
    });
}

function add(pkos) {
  
  console.log(pkos);
  const payload = jsona.serialize({
    stuff: pkos,
    includeNames: null
  });
  console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/fms/fms_pkos`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(pko) {
  const payload = jsona.serialize({
    stuff: pko,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };
 
  return axios.patch(`${url}/fms/fms_pkos/${pko.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/fms/fms_pkos/${id}`, options);
}

function last_no() {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/fms/fms_pkos/last/no`, options)
    .then(response => {
      return response.data;
    });
}

function update_status(pkos) {
  const payload = jsona.serialize({
    stuff: pkos,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/fms/fms_pkos/update_status/${pkos.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function download_doc_agreement(id) {

  const options = {
    headers: {
      'Accept': '*/*',
      // 'Content-Type': 'application/vnd.api+json',
    },
    responseType: 'blob',
  };

  return axios.get(`${url}/fms/fms_pkos/doc/agreement/${id}`, options)
    .then(response => {
      return response.data;
    });
}




export default {
  list,
  get,
  add,
  update,
  destroy,
  last_no,
  update_status,
  download_doc_agreement,
};

